/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./style.css";
import Loading from "../Loading/Loading";

function StudentLeaderBoard({ id, title }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  let totalPointsSum = 0;
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const apiUrl = `${process.env.REACT_APP_API_URL}/wp-json/gamipress/v1/student-weekly-summary/${id}`;
        const response = await axios.get(apiUrl);
        setData(response.data.results);
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };
    fetchData();
  }, [id]);
  return loading ? (
    <Loading />
  ) : (
    <div>
      <div className="week">
        <div className="week_container">
          <div className="period">Week Period</div>
          <div className="total_correct">Total Correct</div>
          <div className="total_question">Total Questions</div>
          <div className="total_report">Total Points</div>
        </div>

        {data.length ? (
          data.map((week_report, index) => {
            totalPointsSum += parseInt(week_report.total_points);
            return (
              <div className="week_container" key={index}>
                <div className="period">{week_report.week_period}</div>
                <div className="total_correct">{week_report.total_correct}</div>
                <div className="total_question">
                  {week_report.total_questions}
                </div>
                <div className="total_report">
                  {week_report.total_points} PTS
                </div>
              </div>
            );
          })
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              fontSize: "1.5rem",
              color: "white",
            }}
          >
            {title}
          </div>
        )}
        <div className="week_container">
          <div className="period">Total Points </div>
          <div className="total_report">{totalPointsSum} PTS</div>
        </div>
      </div>
    </div>
  );
}
export default StudentLeaderBoard;
